export default __webpack_public_path__ + "static/media/nightowl-alert-circle.03a5ecd3.svg";